<div class="phone-consult">
  <div class="wrap">
    <div class="box-text">
      <div class="tit">
        <span>전화 상담 바로가기</span>
      </div>
    </div>
    <div class="box-icon">
      <mat-icon class="icon">keyboard_arrow_right</mat-icon>
    </div>
    <div class="box-image">
      <img class="img" src="assets/images/ch_icon_09.png">
    </div>
  </div>
</div>
